module.exports = __webpack_public_path__ + "img/firma-nicolas.df57bbb6.png";